import React from 'react';
import { Box } from '@mui/material';
import AdminCompanyEdit from './AdminCompanyEdit';
import AdminCompanyTracking from './AdminCompanyTracking';
import AdminAspiringTracking from './AdminAspiringTracking';
import AdminCompanyPayments from './AdminCompanyPayments';
import AdminBotPanel from './AdminBotPanel';
import AdminHolidays from './AdminHolidays';
import AdminTgbTracking from './AdminTgbTracking';
import AdminSystem from './AdminSystem';
import Reminders from './Reminders';
import Announcements from './Announcements';
import AdminProjectTracking from './AdminProjectTracking';

function AdminContent({ content }) {
  return (
    <Box id="MainBody">
      {content === 0 && <AdminCompanyEdit />}
      {content === 1 && <AdminCompanyTracking />}
      {content === 8 && <AdminAspiringTracking />}
      {content === 2 && <AdminProjectTracking />}
      {content === 3 && <AdminCompanyPayments />}
      {content === 4 && <Reminders />}
      {content === 9 && <Announcements />}
      {content === 5 && <AdminBotPanel />}
      {content === 6 && <AdminHolidays />}
      {content === 10 && <AdminTgbTracking />}
      {content === 7 && <AdminSystem />}
    </Box>
  );
}

export default AdminContent;
